export function isObject(value) {
    return value !== null && typeof value === 'object';
}
export function isPromiseLike(value) {
    return isObject(value) && typeof value.then === 'function';
}
//# sourceMappingURL=types.js.map